import { useEffect, useState } from "react";
import { useLocation, useHistory } from "react-router-dom";
import TutorSpaceNavLogo from './TutorSpaceNavLogo.png';
import emailjs from 'emailjs-com'
import { ref, getDownloadURL } from "firebase/storage";

import {
  doc,
  onSnapshot,
  collection,
  query,
  where,
  updateDoc,
  arrayUnion,
  arrayRemove,
  setDoc,
  deleteDoc,
  getDoc,
  getDocs
} from "firebase/firestore";

import {
  GoogleAuthProvider,
  getAuth,
  signInWithPopup,
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  sendPasswordResetEmail,
  signOut,
  signInWithCustomToken
} from "firebase/auth";

import {
  auth,
  db,
  getNames,
  storage
} from "../../firebase.client.js";

import {
  decryptUserId,
  validateCode,
  fetchSecretKey,
  createAuthUrl,
  generateCode
} from "./validation.js";
import { set } from "date-fns";

const SERVICE_ID = "service_dkpu0xg";
const TEMPLATE_ID = "template_dl286wa";
const PUBLIC_KEY = "edOZ3RcvJlykFj1p4";

async function createRecordAndSendEmail(userName, password, agent, agentEmail) {
  try {
    const templateParams = {
      password: password,
      user_name: userName,
      agent: agent,
      agent_email: agentEmail,
    };
    //console.log('Template Params:', templateParams);
    const response = await emailjs.send(
      SERVICE_ID,
      TEMPLATE_ID,
      templateParams,
      PUBLIC_KEY
    );
    console.log("User Creation Email Sent:", response.status, response.text);
  } catch (err) {
    console.error("Failed to send email. Error:", err);
  }
}

async function registerWithEmailAndPassword(
  email,
  password,
  name,
  testType,
  userId = "Student",
  companyCode = "",
  IsLimited = false,
  selectedAgentName = "",
  IsOnlyDiagnostic = false,
  has504 = false
 
) {
  try {
    const userCredential = await createUserWithEmailAndPassword(auth, email, password);
    const newUser = userCredential.user;
    const idToken = await newUser.getIdToken();
    const uid = newUser.uid;
    const userDocRef = doc(collection(db, "users"));

    await setDoc(userDocRef, {
      name,
      email,
      idToken,
      userId,
      uid,
      isNewCompany: false,
      authProvider: "local",
      Type: "Individual",
      BluebookGrade: "200%200%200%200%200%200%200%200%200%200%200%200",
      Test1: "Student answer+++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++",
      Test2: "Student answer+++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++",
      Test3: "Student answer+++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++",
      Test4: "Student answer+++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++",
      Test5: "Student answer+++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++",
      Test6: "Student answer+++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++",
      Test7: "Student answer+++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++",
      Test8: "Student answer+++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++",
      Test9: "Student answer+++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++",
      Test10: "Student answer+++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++",
      Test11: "Student answer+++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++",
      Test12: "Student answer+++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++",
      Test13: "Student answer+++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++",
      Test14: "Student answer+++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++",
      Test15: "Student answer+++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++",
      Test16: "Student answer+++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++",
      Test1ACT: "Student answer+++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++",
      Test2ACT: "Student answer+++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++",
      Test3ACT: "Student answer+++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++",
      Test4ACT: "Student answer+++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++",
      Test5ACT: "Student answer+++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++",
      Test6ACT: "Student answer+++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++",
      Test7ACT: "Student answer+++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++",
      Test8ACT: "Student answer+++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++",
      Test9ACT: "Student answer+++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++",
      Test10ACT: "Student answer+++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++",
      DiagnosticsTestResults:
        "Student answer+++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++",
      assignmentsArc: "",
      assignmentsDone: "",
      QuizResults: "",
      topics: "",
      ClassDate: new Date(),
      NextMeetingDate: new Date(),
      Notepad: "",
      assignments: "",
      HistMeetingTimes: [],
      HistMeetingTimesEnd: [],
      Tutor: "",
      Test: testType,
      TutorNotes: "",
      Improvement: "",
      PhoneNumber: "9999999999",
      SVG: "",
      CompanyCode: companyCode,
      ConnectedAccountCreated: true,
      StartTime: new Date(),
      DisableService: true,
      IsIndividual: true,
      ShowBlueebook: false,
      TestDate: new Date(),
      timeSpent: 0,
      timeSpentThisWeek: 0,
      LastTimeMarked: new Date(),
      Agent: selectedAgentName,
      IsLimited: IsLimited,
      IsOnlyDiagnostic: IsOnlyDiagnostic,
      has504: has504,
    });

    return userCredential;
  } catch (error) {
    throw error;
  }
}

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const formatWithSpaces = (value) => {
  if(value.toLowerCase().includes('diagnostic')){
    return "SAT/ACT Diagnostic";
  }
  return value.replace(/([A-Z])/g, " $1").trim();
};

const AuthPage = () => {
  const [showLogin, setShowLogin] = useState(false);
  const [loginEmail, setLoginEmail] = useState("");
  const [loginPassword, setLoginPassword] = useState("");
  const [loginError, setLoginError] = useState(null);
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [repeatPassword, setRepeatPassword] = useState("");
  const [name, setName] = useState("");
  const [testType, setTestType] = useState("");
  const [signUpError, setSignUpError] = useState(null);

  const history = useHistory();
  const queryLocal = useQuery();
  const companyCode = queryLocal.get("companyCode") || "";
  const authKeyParam = queryLocal.get("authKey");
  const ivParam = queryLocal.get("iv");

  const [NameId, setNameId] = useState([]);
  const usersRef = collection(db, "users");
  const [agentList, setAgentList] = useState([]);

  const [IsLimited, setIsLimited] = useState(false);
  const [isOnlyDiagnostic, setIsOnlyDiagnostic] = useState(false);

  const [has504, setHas504] = useState(false);

    const [dynamicLogo, setDynamicLogo] = useState();
    const [dynamicLogoBool, setDynamicLogoBool] = useState(false);
  
    const getPartnerLogo = async (companyCode) => {
      try {
      const jsonRef = ref(storage, 'gs://tutorspace-7a7f1.appspot.com/PartnerImageAssets/' + companyCode + '.png');
      const url = await getDownloadURL(jsonRef);
      return url;
      } catch (error) {
      console.error("Error fetching image URL:", error);
      throw error;
      }
    };
  
    useEffect(() => {
      
      async function fetchAndSetPartnerLogo() {
      try {

        const possibleLogoUrl = await getPartnerLogo(companyCode);
        if (possibleLogoUrl) {
        setDynamicLogo(possibleLogoUrl);
        setDynamicLogoBool(true);
        }
      } catch (err) {
        console.error("Partner logo not found:", err);
        setDynamicLogo(TutorSpaceNavLogo);
        setDynamicLogoBool(false);
      }
      }
      if(companyCode != undefined && companyCode != '' && companyCode != 'none' && companyCode != 'None'){
        fetchAndSetPartnerLogo();
      }
    }, [companyCode]);

  
  const [usesAgent, setUsesAgent] = useState(false);

  useEffect(() => {
    const agents = [
      ["Danny Umali", "danny@gametheorycollege.com"],
      ["Mark Williams", "mark@collegefa.com"],
      ["Adam Toohey", "adam@nwcollegesolutions.com"],
      ["Brian Toohey", "briantoohey31@gmail.com"],
      ["Ben Buso", "ben@gametheorycollege.com"],
      ["Jim McKinney", "james@capitolcp.com"],
      ["Nathan Tanner", "nathan@collegepros.net"],
      ["Jarad Stolz", "Jarad@dibcompanies.com"],
      ["Mike Marchi", "thecollegeservicesgroup@gmail.com"],
      ["Mike Dusonbre", "mike@dibcompanies.com"],
      ["Steve Haynes", "steve@gametheorycollege.com"],
      ["Joseph Tauzin", "joseph@tutorspace.app"],
    ];

    if (
      companyCode.toLowerCase() === "gametheoryplanners" ||
      companyCode.toLowerCase() === "gametheorycollegeplanners"
    ) {
      setAgentList(agents);
      setUsesAgent(true);
    }

    if (companyCode.toLowerCase() === "individual" || companyCode.toLowerCase() == 'maxpotentiallearning') {
      setIsLimited(true);
    }
    if (companyCode.toLowerCase().includes("diagnostic")) {
      setIsOnlyDiagnostic(true);
      setTestType('SAT');
    }
  }, [companyCode]);

  const [selectedAgentName, setSelectedAgentName] = useState("");
  const [selectedAgentEmail, setSelectedAgentEmail] = useState("");

  useEffect(() => {
    const z = query(usersRef);
    getDocs(z).then((querySnapshot) => {
      if (NameId && companyCode) {
        let arr = [];
        querySnapshot.docs.forEach((doc) => {
          const d = doc.data();
          if (d && d.name && d.uid && d.Type && d.CompanyCode === companyCode) {
            arr.push([d.name]);
          }
        });
        setNameId(arr.filter((item) => item[3] !== "Parent"));
      }
    });
  }, [companyCode, NameId, usersRef]);

  useEffect(() => {
    const agent = agentList.find(([name]) => name === selectedAgentName);
    setSelectedAgentEmail(agent ? agent[1] : "");
  }, [selectedAgentName, agentList]);

  //console.log("Selected Agent Email:", selectedAgentEmail);
  //console.log("Selected Agent Name:", selectedAgentName);

  function ShowAgent() {
    if (
      companyCode.toLowerCase() === "gametheoryplanners" ||
      companyCode.toLowerCase() === "gametheorycollegeplanners"
    ) {
      return (
        <div className="mb-6">
          <label className="block text-blue-700 mb-2 font-medium">
            Select Your Agent
          </label>
          <select
            value={selectedAgentName}
            onChange={(e) => setSelectedAgentName(e.target.value)}
            className="w-full p-3 border border-blue-200 rounded focus:outline-none focus:border-blue-400"
          >
            <option value="">-- Choose a name --</option>
            {agentList.map((item, idx) => (
              <option key={idx} value={item[0]}>
                {item[0]} 
              </option>
            ))}
          </select>
        </div>
      );
    }
    return null;
  }

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoginError(null);
    try {
      await signInWithEmailAndPassword(auth, loginEmail, loginPassword);
      history.push("/c/dashboard");
      window.location.reload();
    } catch {
      setLoginError("Login failed. Please check your credentials.");
    }
  };

  const handleResetPassword = async () => {
    if (!loginEmail) {
      setLoginError("Please enter your email above first.");
      return;
    }
    try {
      await sendPasswordResetEmail(auth, loginEmail);
      setLoginError("Password reset link sent, check inbox.");
    } catch {
      setLoginError("Failed to send reset email.");
    }
  };

  function IsUserNameInUse(n) {
    return NameId.some((item) => item[0] === n);
  }

  const handleSignUp = async (e) => {
    e.preventDefault();
    setSignUpError(null);
    if (password !== repeatPassword) {
      setSignUpError("Passwords do not match");
      return;
    }
    if (password.length < 8) {
      setSignUpError("Password must be at least 8 characters long.");
      return;
    }
    let userId = "Student";
    if (authKeyParam) {
      try {
        const encryptedData = { iv: ivParam, authKey: authKeyParam };
        const decrypted = await decryptUserId(encryptedData);
        if (decrypted) userId = decrypted;
      } catch {}
    }
    try {
      await registerWithEmailAndPassword(email, password, name, testType, userId, companyCode, IsLimited, selectedAgentName, isOnlyDiagnostic, has504);
      await createRecordAndSendEmail(email, password, selectedAgentName, selectedAgentEmail);
      setTimeout(() => {
        history.push("/c/dashboard");
        window.location.reload();
      }, 500);
    } catch (err) {
      if (err.code === "auth/weak-password") {
        setSignUpError("Password must be at least 6 characters.");
      } else if (err.code === "auth/email-already-in-use") {
        setSignUpError("This email is already in use.");
      } else if (err.code === "auth/invalid-email") {
        setSignUpError("Invalid email format.");
      } else {
        setSignUpError("Error creating account. Please try again.");
      }
    }
  };

  const requireAgent =
    companyCode.toLowerCase() === "gametheoryplanners" ||
    companyCode.toLowerCase() === "gametheorycollegeplanners";

  const isDisabled =
    !email ||
    !password ||
    !name ||
    password !== repeatPassword ||
    testType === "" ||
    testType === "Select Test" ||
    IsUserNameInUse(name) ||
    (requireAgent && !selectedAgentName);

  const errorMessage = () => {
    if (!email) return "Email is required.";
    if (!name) return "Name is required.";
    if (!password) return "Password is required.";
    if (password !== repeatPassword) return "Passwords do not match.";
    if (password.length < 8) return "Password must be at least 8 characters.";
    if (testType === "" || testType === "Select Test") return "Please select a test type.";
    if (IsUserNameInUse(name)) return "Name is already in use.";
  
    if (requireAgent && !selectedAgentName) return "Please select an agent.";
    return "";
  };

  return (
    <div className="min-h-screen relative flex items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-100 px-4">
      {/* logo */}
      <a href="/" className="absolute top-4 left-4 flex items-center gap-2">
        <img
          src={dynamicLogo}
          alt="TutorSpace"
          className={`${dynamicLogoBool ? "h-28 md:h-32" : "h-14 md:h-16"} drop-shadow-lg`}
        />
      </a>
  
      {/* frosted card */}
      <div className="w-full max-w-lg bg-white/70 backdrop-blur-lg rounded-2xl shadow-2xl ring-1 ring-white/40 overflow-y-auto max-h-[calc(100vh-6rem)]">
        <div className="p-6 sm:p-10">
          {/* switch button */}
          <div className="flex justify-center mb-6">
            <button
              onClick={() => setShowLogin(p => !p)}
              className="rounded-full bg-gray-100 hover:bg-gray-200 text-gray-700 px-6 py-2 transition"
            >
              {showLogin ? "Switch to Sign Up?" : "Switch to Login?"}
            </button>
          </div>
  
          {/* ---------------- SIGN-UP ---------------- */}
          {!showLogin ? (
            <form onSubmit={handleSignUp} className="space-y-5">
              <h3 className="text-center text-3xl font-bold text-blue-700">
                {companyCode ? formatWithSpaces(companyCode) : "Create an Account"}
              </h3>
  
              {signUpError && <p className="text-red-500">{signUpError}</p>}
              {ShowAgent()}
  
              {/* name */}
              <div>
                <label className="block text-blue-700 font-medium mb-1">Name</label>
                <input
                  type="text"
                  value={name}
                  onChange={e => setName(e.target.value)}
                  placeholder="Full Name"
                  required
                  className="w-full rounded border px-4 py-3 focus:ring-2 focus:ring-blue-400 transition"
                />
              </div>
  
              {/* email */}
              <div>
                <label className="block text-blue-700 font-medium mb-1">Email</label>
                <input
                  type="email"
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  placeholder="Email"
                  required
                  className="w-full rounded border px-4 py-3 focus:ring-2 focus:ring-blue-400 transition"
                />
              </div>
  
              {/* test type */}
              {!isOnlyDiagnostic && (
                <div>
                  <label className="block text-blue-700 font-medium mb-1">Test Type</label>
                  <select
                    value={testType}
                    onChange={e => setTestType(e.target.value)}
                    required
                    className="w-full rounded border px-4 py-3 focus:ring-2 focus:ring-blue-400 transition bg-white"
                  >
                    <option value="">Select Test</option>
                    <option value="ACT">ACT</option>
                    <option value="SAT">SAT</option>
                  </select>
                </div>
              )}
  
           
              <div>
                <label className="block text-blue-700 font-medium mb-1">
                  504 accommodations?
                </label>
                <select
                  value={has504 ? "Yes" : "No"}
                  onChange={e => setHas504(e.target.value === "Yes")}
                  required
                  className="w-full rounded border px-4 py-3 focus:ring-2 focus:ring-blue-400 transition bg-white"
                >
                  <option value="">Select</option>
                  <option value="Yes">Yes</option>
                  <option value="No">No</option>
                </select>
              </div>
              <div>
                <label className="block text-blue-700 font-medium mb-1">Password</label>
                <input
                  type="password"
                  value={password}
                  onChange={e => setPassword(e.target.value)}
                  placeholder="Password"
                  required
                  className="w-full rounded border px-4 py-3 focus:ring-2 focus:ring-blue-400 transition"
                />
              </div>
  
              {/* repeat password */}
              <div>
                <label className="block text-blue-700 font-medium mb-1">Repeat Password</label>
                <input
                  type="password"
                  value={repeatPassword}
                  onChange={e => setRepeatPassword(e.target.value)}
                  placeholder="Repeat Password"
                  required
                  className="w-full rounded border px-4 py-3 focus:ring-2 focus:ring-blue-400 transition"
                />
              </div>
  
              {usesAgent && (
                <p className="text-blue-700 text-sm">
                  Your username/password will be sent to your agent
                </p>
              )}
  
              {/* submit */}
              <div className="relative">
                <button
                  type="submit"
                  disabled={isDisabled}
                  className={`w-full py-3 rounded-full text-white font-semibold transition
                    ${
                      isDisabled
                        ? "bg-blue-300 cursor-not-allowed"
                        : "bg-gradient-to-r from-blue-500 to-indigo-500 hover:brightness-110"
                    }`}
                >
                  Sign Up
                </button>
                {isDisabled && (
                  <div className="absolute top-full mt-2 w-full rounded bg-gray-800 text-white text-xs p-2 text-center shadow-lg">
                    {errorMessage()}
                  </div>
                )}
              </div>
            </form>
          ) : (
            /* ---------------- LOG-IN ---------------- */
            <form onSubmit={handleLogin} className="space-y-5">
              <h3 className="text-center text-3xl font-bold text-blue-700">
                {companyCode ? formatWithSpaces(companyCode) : "Log In"}
              </h3>
  
              {loginError && <p className="text-red-500">{loginError}</p>}
  
              {/* email */}
              <div>
                <label className="block text-blue-700 font-medium mb-1">Email</label>
                <input
                  type="email"
                  value={loginEmail}
                  onChange={e => setLoginEmail(e.target.value)}
                  placeholder="Email"
                  required
                  className="w-full rounded border px-4 py-3 focus:ring-2 focus:ring-blue-400 transition"
                />
              </div>
  
              {/* password + show/hide */}
              <div>
                <label className="block text-blue-700 font-medium mb-1">Password</label>
                <div className="relative">
                  <input
                    type={isPasswordVisible ? "text" : "password"}
                    value={loginPassword}
                    onChange={e => setLoginPassword(e.target.value)}
                    placeholder="Password"
                    required
                    className="w-full rounded border px-4 py-3 focus:ring-2 focus:ring-blue-400 transition"
                  />
                  <button
                    type="button"
                    onClick={() => setIsPasswordVisible(!isPasswordVisible)}
                    className="absolute right-3 top-1/2 -translate-y-1/2 text-sm text-blue-700 hover:text-blue-900"
                  >
                    {isPasswordVisible ? "Hide" : "Show"}
                  </button>
                </div>
              </div>
  
              <div className="text-right">
                <button
                  type="button"
                  onClick={handleResetPassword}
                  className="text-blue-500 hover:text-blue-700 text-sm"
                >
                  Forgot Password?
                </button>
              </div>
  
              <button
                className="w-full py-3 rounded-full bg-gradient-to-r from-blue-500 to-indigo-500 text-white font-semibold hover:brightness-110 transition"
              >
                Log In
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
  
  
};

const SignUp = ({ authKey, company }) => {
  const [email, setEmail] = useState();
  const [password, setPassword] = useState();
  const [repeatPassword, setRepeatPassword] = useState("");
  const [name, setName] = useState("");
  const [error, setError] = useState(null);
  const [testType, setTestType] = useState("");

  const history = useHistory();
  const queryLocal = useQuery();
  const companyCode = queryLocal.get("companyCode");
  const errorMessage = () => {
    if (!email) return "Email is required.";
    if (!name) return "Name is required.";
    if (!password) return "Password is required.";
    if (password !== repeatPassword) return "Passwords do not match.";
    if (testType === "" || testType === "Select Test")
      return "Please select a test type.";
    return "";
  };

  const SignUpButton = ({ email, password, repeatPassword, name, testType }) => {
    const [showTooltip, setShowTooltip] = useState(false);
    const isDisabled =
      !email ||
      !password ||
      !name ||
      password !== repeatPassword ||
      testType === "" ||
      testType === "Select Test";

    return (
      <div className="relative w-full">
        <button
          type="submit"
          className={`w-full bg-blue-500 text-white p-2 rounded mt-4 ${
            isDisabled ? "cursor-not-allowed" : ""
          }`}
          disabled={isDisabled}
          onMouseEnter={() => setShowTooltip(true)}
          onMouseLeave={() => setShowTooltip(false)}
        >
          Sign Up
        </button>
      </div>
    );
  };

  const handleSignUp = async (e) => {
    e.preventDefault();
    setError(null);
    if (password !== repeatPassword) {
      setError("Passwords do not match");
      return;
    }
    let userId = "Student";
    try {
      if (authKey) {
        const decryptedId = await decryptUserId(authKey);
        if (!decryptedId) {
          console.error("Decryption failed. No userId could be retrieved.");
          setError("Decryption failed. Please try again.");
        } else {
          userId = decryptedId;
        }
      }
    } catch (error) {
      console.error("Error decrypting:", error);
    }

    try {
      await registerWithEmailAndPassword(
        email,
        password,
        name,
        testType,
        userId,
        companyCode
      );
      history.push("/c/dashboard");
      window.location.reload();
    } catch (error) {
      console.error("Error creating account", error);
      setError("Error creating account. Please try again.");
    }
  };

  const encryptedData = {
    iv: "NEJX6PCSt0FdePUO",
    authKey: "1ETQn1td86z-S9gKoRMkBDOKFyl3f2zlyOqzqEc",
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-blue-50 relative">
      <div className="absolute top-0 left-0 m-6">
        <a href="/">
          <img src={TutorSpaceNavLogo} alt="Logo" className="h-16" />
        </a>
      </div>
      <form
        onSubmit={handleSignUp}
        className="bg-white p-8 md:p-10 rounded-xl shadow-md max-w-md w-full"
      >
        <h3 className="text-center text-2xl text-blue-700 mb-6 font-semibold">
          {formatWithSpaces(companyCode)}
        </h3>
        {error && <p className="text-red-500 text-sm mb-4">{error}</p>}
        <div className="mb-6">
          <label htmlFor="name" className="block text-blue-700 mb-2 font-medium">
            Name
          </label>
          <input
            type="text"
            id="name"
            value={name || ""}
            onChange={(e) => setName(e.target.value)}
            className="w-full p-3 border border-blue-200 rounded focus:outline-none focus:border-blue-400 transition-colors"
            placeholder="Full Name"
            required
          />
        </div>
        <div className="mb-6">
          <label htmlFor="email" className="block text-blue-700 mb-2 font-medium">
            Email
          </label>
          <input
            type="email"
            id="email"
            value={email || ""}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full p-3 border border-blue-200 rounded focus:outline-none focus:border-blue-400 transition-colors"
            placeholder="Email"
            required
          />
        </div>
        <div className="mb-6">
          <label
            htmlFor="testType"
            className="block text-blue-700 mb-2 font-medium"
          >
            Test Type (You can change later)
          </label>
          <select
            id="testType"
            value={testType}
            onChange={(e) => setTestType(e.target.value)}
            className="w-full p-3 border border-blue-200 rounded focus:outline-none focus:border-blue-400 transition-colors"
            required
          >
            <option value="">Select Test</option>
            <option value="ACT">ACT</option>
            <option value="SAT">SAT</option>
          </select>
        </div>
        <div className="mb-6">
          <label
            htmlFor="password"
            className="block text-blue-700 mb-2 font-medium"
          >
            Password
          </label>
          <input
            type="password"
            id="password"
            value={password || ""}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full p-3 border border-blue-200 rounded focus:outline-none focus:border-blue-400 transition-colors"
            placeholder="Password"
            required
          />
        </div>
        <div className="mb-8">
          <label
            htmlFor="repeatPassword"
            className="block text-blue-700 mb-2 font-medium"
          >
            Repeat Password
          </label>
          <input
            type="password"
            id="repeatPassword"
            value={repeatPassword || ""}
            onChange={(e) => setRepeatPassword(e.target.value)}
            className="w-full p-3 border border-blue-200 rounded focus:outline-none focus:border-blue-400 transition-colors"
            placeholder="Repeat Password"
            required
          />
        </div>
        {SignUpButton({ email, password, repeatPassword, name, testType })}

        <button
          type="button"
          className="w-full mt-6 text-blue-600 hover:text-blue-800 transition-colors mt-20"
          onClick={() => history.push("/login")}
        >
          Already have an account? Log in
        </button>
      </form>
    </div>
  );
};

const AutoSignIn = () => {
  const [loading, setLoading] = useState(true);
  const [userExists, setUserExists] = useState(false);
  const queryLocal = useQuery();

  const authKey = queryLocal.get("authKey");
  const iv = queryLocal.get("iv");
  const providedCode = queryLocal.get("code");
  const providedTimestamp = queryLocal.get("timestamp");
  const companyCode = queryLocal.get("companyCode") || "";

  const history = useHistory();

  const encryptedData = {
    iv: iv,
    authKey: authKey,
  };

  const fetchCustomToken = async (uid) => {
    try {
      const response = await fetch(
        `https://josephtauzin.pythonanywhere.com/generate-token?uid=${uid}`
      );
      const data = await response.json();
      return data.customToken;
    } catch (error) {
      console.error("Error fetching custom token: ", error);
      return null;
    }
  };

  useEffect(() => {
    const checkUserExists = async () => {
      if (authKey && providedCode && providedTimestamp) {
        try {
          const userId = await decryptUserId(encryptedData);
          if (!userId) {
            console.error("Decryption failed. No userId could be retrieved.");
            setLoading(false);
            return;
          }
          const validationResult = await validateCode(
            userId,
            providedCode,
            providedTimestamp
          );
          if (!validationResult.valid) {
            console.error("Invalid code or expired timestamp.");
            setLoading(false);
            return;
          }
          const q = query(collection(db, "users"), where("userId", "==", userId));
          const userQuerySnapshot = await getDocs(q);

          if (!userQuerySnapshot.empty) {
            const userDoc = userQuerySnapshot.docs[0];
            const { uid } = userDoc.data();
            const customToken = await fetchCustomToken(uid);
            if (!customToken) {
              console.error("Failed to fetch custom token");
              setLoading(false);
              return;
            }
            signInWithCustomToken(auth, customToken)
              .then(() => {
                setUserExists(true);
                setLoading(false);
                history.push("/c/dashboard");
                window.location.reload();
              })
              .catch((error) => {
                console.error("Auto sign-in failed", error);
                setLoading(false);
              });
          } else {
            setUserExists(false);
            setLoading(false);
          }
        } catch (error) {
          console.error("Error checking user existence: ", error);
          setLoading(false);
        }
      } else {
        setLoading(false);
      }
    };

    checkUserExists();
  }, [authKey, providedCode, providedTimestamp, history]);

  return <AuthPage />;
};

export default AutoSignIn;
